import React from "react";
import { useParams } from "react-router-dom";
import AdapterEditor from "../../components/adapters/AdapterEditor";
import useLeaveStandaloneEditor from "../../../customHooks/useLeaveStandaloneEditor";

export default function AdaptersEdit() {
  const leave = useLeaveStandaloneEditor("/edge-management/adapters");
  const { adapterId } = useParams<{ adapterId: string }>();

  return (
    <AdapterEditor
      mode="page"
      existingAdapterId={adapterId || undefined}
      formAction="edit"
      onSaveSuccess={leave}
      onCancel={leave}
    />
  );
}
